import api from "../base-url";
import { mutate } from 'swr';

async function deleteUser(id: number) {

  try {
  let res = await api.delete(`/users/${id}`);
  console.log(res.status);
  if(res.status > 200 && res.status < 300) {
    mutate(`/users`);
  }
  return res.status;
} catch (error: any) {
  if (error.response) {
  console.log("error status", error.response.status)
  return error.response.status
}
}
}

export default deleteUser;